import { useEffect, useState } from "react";
import UnAuthComponent from "../layout/unauth.component";
import { ViewTextLabels, appNote, buttonLabels } from "../shared/constants";
import { ArrowForwordIcon, FbIcon, GoogleLoginIcon, HidePassword, InstaIcon, LinkdinIcon, MicrosoftLoginIcon2, ShowPassword, WebIcon, YoutubeIcon, FalkonchatSignUpIcon, FalkonchatIcon, SuccessIcon, LinkExpired, LoginBgTop, EmailSentSuccessIcon } from "../../icon";
import { FormHelperText, InputAdornment, TextField, Tooltip, Zoom } from "@mui/material";
import { Link } from "react-router-dom";
import { AppRoutes } from "../routes/route.path";
import { validateForm } from "../shared/form-validation";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { ChannelAuthService } from "../../services/ChannelAuthService";
import FallbackUIComponent from "../shared/fallback-ui/fallback-page.component";
import ButtonComponent from "../shared/button/button.component";
import PasswordRequirements from "../login/password-requriements.component";

const ChannelsSetPasswordComponent = (props) => {
    const navigate = useNavigate();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp);

    const [state, setState] = useState({
        resetnewpassword: "",
        confirmPassword: "",
        showPassword: false,
        showConfirmPassword: false,
        errors: {
            resetnewpassword: "",
            confirmPassword: "",
        },
        isDownloadIconHovered: {
            name: "",
            isHovered: false
        },
        isValidatingToken: true,
        IsValidToken: true,
        isPasswordSetSuccessfull: false,
        isLoading: false,
        failedValidTokenErrorMsg: ""
    });

    const handleChange = (name: string, value: any) => {
        setState({ ...state, [name]: value });
    };

    const handleConfirmPasswordChange = (name: string, value: any) => {
        setState({ ...state, [name]: value, });
    };

    useEffect(() => {
        if (state.resetnewpassword.trim() !== '') {
            validateForm({
                resetnewpassword: state.resetnewpassword,
                confirmPassword: {
                    newPassword: state.resetnewpassword,
                    confirmPassword: state.confirmPassword
                }
            },
                (Errors) => {
                    setState({ ...state, errors: { ...state.errors, ...Errors } });
                })
        }
    }, [state.resetnewpassword, state.confirmPassword])


    const onClickShowPassword = () => {
        setState((prevState) => ({ ...prevState, showPassword: !state.showPassword }));
    }

    const handleSubmit = () => {
        var urlParams = new URLSearchParams(window.location?.search);
        var token = urlParams.get("token") || null;
        if (validateForm({
            resetnewpassword: state.resetnewpassword,
            confirmPassword: !!state.confirmPassword ? {
                newPassword: state.resetnewpassword,
                confirmPassword: state.confirmPassword
            } : state.confirmPassword
        },
            (Errors) => {
                setState({ ...state, errors: { ...state.errors, ...Errors } })
            })) {
            setState({ ...state, isLoading: true })
            ChannelAuthService.resetpassword({ token: token, password: state.confirmPassword }).then((res) => {
                setState({ ...state, isPasswordSetSuccessfull: true, resetnewpassword: "", confirmPassword: "", isLoading: false, })
            }).catch((err) => {
                setState({ ...state, isPasswordSetSuccessfull: false, resetnewpassword: "", confirmPassword: "", isLoading: false })
            })
        }
    }

    const validateToken = () => {
        var urlParams = new URLSearchParams(window.location?.search);
        var token = urlParams.get("token") || null;
        var email = urlParams.get("email") || null;
        setState({ ...state, isValidatingToken: true })
        if (email === "true") {
            ChannelAuthService.verifyEmailToken(token).then((res) => {
                setState({ ...state, IsValidToken: res.data === "Email verified" ? true : false, isValidatingToken: false })
            }).catch((err) => {
                setState({ ...state, IsValidToken: false, isValidatingToken: false, failedValidTokenErrorMsg: err.response.data })
            })
        } else {
            ChannelAuthService.verifyInvitationToken(token).then((res) => {
                setState({ ...state, IsValidToken: res.data === "Verification failed" ? false : true, isValidatingToken: false })
            }).catch((err) => {
                setState({ ...state, IsValidToken: false, isValidatingToken: false, failedValidTokenErrorMsg: err?.response?.data })
            })
        }
    }

    useEffect(() => {
        validateToken();
    }, [])



    return (
        <div className="w-p-100 h-v-100 d-flex flex-direction justify-center align-center">
            <div className={`w-p-100 h-p-10 d-flex align-end pl-12`}>
                <FalkonchatIcon />
            </div>
            {!IsMobileDevice &&
                <div className="p-absolute r-0 t-0" style={{ zIndex: -1 }}>
                    <LoginBgTop />
                </div>
            }
            <div className="w-p-100 h-p-90 d-flex justify-center align-center">
                {state.isValidatingToken ?
                    <FallbackUIComponent className='w-p-100' />
                    : state.IsValidToken ?
                        !state.isPasswordSetSuccessfull ?
                            <div className="d-flex justify-center flex-direction align-center w-p-70 h-p-50 max-w-90">
                                <div className="w-p-100 h-p-100 d-flex">
                                    <div className="w-p-50 h-p-100">
                                        <div className="w-p-100 h-p-16 color-login-headers h1-semibold">
                                            Update Password
                                        </div>
                                        <div className="w-p-100 h-p-84">
                                            <PasswordRequirements passwordCheck={state.resetnewpassword} IsMobileDevice={IsMobileDevice} />
                                        </div>
                                    </div>
                                    <div className="w-p-50 h-p-100">
                                        <div className="w-p-100 h-p-26 mt-3">
                                            <TextField
                                                className={`w-p-100 unauth-border ${state.errors.resetnewpassword && "unauth-border-error"}`}
                                                error={
                                                    !!state.errors.resetnewpassword
                                                }
                                                variant="standard"
                                                placeholder="New Password *"
                                                label="New Password *"
                                                fullWidth
                                                name="resetnewpassword"
                                                type={state.showPassword ? "text" : "password"}
                                                id="password"
                                                autoComplete="current-password"
                                                value={state.resetnewpassword}
                                                onChange={(e) => handleChange(e.target.name, e.target.value)} InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position='start' className="c-pointer" onClick={onClickShowPassword}>
                                                            {state.showPassword ? <HidePassword /> : <ShowPassword />}
                                                        </InputAdornment>),
                                                    classes: { input: 'h4-regular w-p-100' }
                                                }}
                                                inputProps={{ maxLength: 20, tabIndex: 2, "data-arrow-index": 7 }}
                                                title=""
                                            />
                                            <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                                {state.errors.resetnewpassword}
                                            </FormHelperText>
                                        </div>
                                        <div className="w-p-100 h-p-26">
                                            <TextField
                                                className={`w-p-100 unauth-border ${state.errors.confirmPassword && "unauth-border-error"}`}
                                                error={
                                                    !!state.errors.confirmPassword
                                                }
                                                variant="standard"
                                                placeholder="Confirm Password *"
                                                label="Confirm Password *"
                                                fullWidth
                                                name="confirmPassword"
                                                type={state.showConfirmPassword ? "text" : "password"}
                                                id="password"
                                                autoComplete="current-password"
                                                value={state.confirmPassword}
                                                onChange={(e) => handleConfirmPasswordChange(e.target.name, e.target.value)} InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position='start' className="c-pointer" onClick={() => setState({ ...state, showConfirmPassword: !state.showConfirmPassword })}>
                                                            {state.showConfirmPassword ? <HidePassword /> : <ShowPassword />}
                                                        </InputAdornment>),
                                                    classes: { input: 'h4-regular w-p-100' }
                                                }}
                                                inputProps={{ maxLength: 20, tabIndex: 2, "data-arrow-index": 7 }}
                                                title=""
                                            />
                                            <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                                {state.errors.confirmPassword}
                                            </FormHelperText>
                                        </div>
                                        <div className={`w-p-100`} >
                                            <button
                                                data-arrow-index={9}
                                                data-up-arrow-index={8}
                                                data-down-arrow-index={9}
                                                data-left-arrow-index={2}
                                                data-right-arrow-index={9}
                                                tabIndex={4}
                                                onClick={() => handleSubmit()}
                                                className={`c-pointer justify-center d-flex w-space h4-regular w-fill br-2 t-align-center bg-color-login-btn color-secondary w-p-100 align-center h-p-100 py-1`}>
                                                {state.isLoading && <span className="mr-1 loader-primary my-auto"></span>}
                                                <span className={"my-auto mr-1"}>Submit</span>
                                                <ArrowForwordIcon />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="d-flex justify-center flex-direction align-center w-p-70 h-p-50 max-w-90">
                                <div className="d-flex h-p-40 align-center mb-4">
                                    <EmailSentSuccessIcon className="mx-auto" />
                                </div>
                                <div className="d-flex">
                                    <div className="m-auto h1-semibold color-login-headers t-align-center">Password setup is complete</div>
                                </div>
                                <div className="d-flex h-p-6">
                                    <span className="m-auto color-login-text-field-font h5-medium t-align-center">Your password has been created successfully</span>
                                </div>
                                <div className=" d-flex h-p-24 mt-2 w-p-100 max-w-50">
                                    <ButtonComponent ButtonLabel={buttonLabels.BACK_TO_LOGIN} Variant={"primary-btn"} ClassName="m-auto w-p-100 py-1 h4-regular bg-color-login-btn" OnClick={() => navigate(AppRoutes.CHANNELS_SIGN_IN)} />
                                </div>
                            </div>
                        :
                        <div className="d-flex justify-center flex-direction align-center w-p-70 h-p-60 max-w-90">
                            <div className="d-flex h-p-50">
                                <LinkExpired className="h-p-100" />
                            </div>
                            <div className="h-p-15 t-align-center">
                                <div className="mx-auto mobile-new-live-chat-header color-primary-danger t-align-center">{`Link expired`}</div>
                                <div className="mx-auto h5-medium color-email-sent-displaymsg">
                                    {`${state.failedValidTokenErrorMsg === "Verification failed" ? "Looks like the verification link has expired." : "Looks like you have already set the password"}`}
                                </div>
                            </div>
                            <div className="d-flex h-p-15 ">
                                <a className="underline m-auto h4-medium color-primary-light " href="https://share.hsforms.com/1uSaLr6GxTn-Mqid2VwLqzgcauh6">Contact support</a>
                            </div>
                        </div>
                }
            </div>
        </div>

    )
}

export default ChannelsSetPasswordComponent;